export function normalizeText(value: string): string {
  return value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
}

export function matchRank(name: string, query: string): 0 | 1 | null {
  const normalizedQuery = normalizeText(query)
  if (!normalizedQuery) return null
  const index = normalizeText(name).indexOf(normalizedQuery)
  if (index === -1) return null
  return index === 0 ? 0 : 1
}

export type HighlightParts = { before: string; match: string; after: string }

export function highlightMatch(text: string, query: string): HighlightParts {
  const normalizedQuery = normalizeText(query)
  const index = normalizedQuery ? normalizeText(text).indexOf(normalizedQuery) : -1
  if (index === -1) return { before: text, match: '', after: '' }
  return {
    before: text.slice(0, index),
    match: text.slice(index, index + query.length),
    after: text.slice(index + query.length),
  }
}
